export class Utils {

  static bytesToSize(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    // eslint-disable-next-line no-restricted-properties
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}

export var filterParams = {
  browserDatePicker: true,
  suppressAndOrCondition: true,
  comparator: function(filterLocalDateAtMidnight, cellValue) {
      var inputs = document.getElementsByClassName("ag-filter-filter");
      for (var i = 0; i < inputs.length; i++) {
          inputs[i].disabled = false;
      }
      var dateAsString = cellValue;
      if (!dateAsString) return -1;
      var dateParts = dateAsString.split("-");
      var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2].substr(0, 2)));
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
          return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
          return 1;
      }
  }
};

export const reducer = (previousValue, currentValue) => previousValue + currentValue;
